import React from 'react';
import { ReactComponent as CompletedIcon } from 'images/completedIcon.svg';
import { Hotkeys } from 'constants/Hotkeys';
import { Option } from '../Option/Option';
import { OptionTitle, TagCatcherThrowsWrapper } from '../TagCatcherThrows/TagCatcherThrowsStyles';

interface IProps {
  onClickCallback: () => void;
  onPressHotkeyCallback: () => void;
  disabled: boolean;
}

const FieldingSequenceOption: React.FC<IProps> = (props) => {
  const { onClickCallback, onPressHotkeyCallback, disabled } = props;

  const getDisplayName = () => {
    if (disabled) {
      return (
        <OptionTitle>
          Fielding Sequence <CompletedIcon />
        </OptionTitle>
      );
    }
    return <>Fielding Sequence</>;
  };

  return (
    <TagCatcherThrowsWrapper>
      <Option
        displayName={getDisplayName()}
        hotkeyCode={Hotkeys.FieldingSequence.Option.keyCode}
        hotkeyDisplay={Hotkeys.FieldingSequence.Option.hotkeyDisplay}
        value=''
        onPressHotkeyCallback={onPressHotkeyCallback}
        onClickCallBack={onClickCallback}
        data-testid='fielding-sequence-option'
      />
    </TagCatcherThrowsWrapper>
  );
};

export default FieldingSequenceOption;
